(function () {
  function initCollectionDescriptionToggle() {
    const desc = document.querySelector('.rte.collection__description');
    if (!desc) return;

    if (desc.dataset.cdcInit === '1') return;

    const collapsedLines = 3;
    desc.style.setProperty('--cdc-lines', String(collapsedLines));

    const lineHeight = parseFloat(getComputedStyle(desc).lineHeight) || 24;
    const approxMax = lineHeight * collapsedLines + 2;
    if (desc.scrollHeight <= approxMax) return;

    const lang = (document.documentElement.lang || 'cs').toLowerCase().slice(0, 2);

    const labels = {
  cs: {
    more: 'ZOBRAZIT VÍCE',
    less: 'ZOBRAZIT MÉNĚ'
  },
  en: {
    more: 'SHOW MORE',
    less: 'SHOW LESS'
  },
  sk: {
    more: 'ZOBRAZIŤ VIAC',
    less: 'ZOBRAZIŤ MENEJ'
  },
  de: {
    more: 'MEHR ANZEIGEN',
    less: 'WENIGER ANZEIGEN'
  }
};

    const t = labels[lang] || labels.cs;

    desc.dataset.cdcInit = '1';
    desc.classList.add('is-collapsed');

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'collection-desc-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = t.more;

    desc.insertAdjacentElement('afterend', btn);

    btn.addEventListener('click', () => {
      const isExpanded = desc.classList.toggle('is-expanded');

      if (isExpanded) {
        desc.classList.remove('is-collapsed');
        btn.textContent = t.less;
        btn.setAttribute('aria-expanded', 'true');
      } else {
        desc.classList.add('is-collapsed');
        btn.textContent = t.more;
        btn.setAttribute('aria-expanded', 'false');
        desc.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initCollectionDescriptionToggle);
  document.addEventListener('page:loaded', initCollectionDescriptionToggle);
  document.addEventListener('shopify:section:load', initCollectionDescriptionToggle);
})();


(function () {
  function openFirstProductTab() {
    const block = document.querySelector('.product-block--tab .collapsibles-wrapper');
    if (!block) return;

    // první collapsible v bloku
    const btn = block.querySelector('.collapsible-trigger');
    if (!btn) return;

    const contentId = btn.getAttribute('aria-controls');
    const content = contentId ? document.getElementById(contentId) : null;

    // vynutit open stav
    btn.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');

    if (content) {
      content.classList.add('is-open');

      // některé šablony používají auto-height a inline height
      content.style.height = 'auto';
    }

    // ikona (někdy má extra třídu)
    const icon = btn.querySelector('.collapsible-trigger__icon');
    if (icon) icon.classList.add('collapsible-trigger__icon--open');
  }

  document.addEventListener('DOMContentLoaded', openFirstProductTab);
  document.addEventListener('page:loaded', openFirstProductTab);
  document.addEventListener('shopify:section:load', openFirstProductTab);
})();
